export interface GeoCoordinates {
  latitude: number;
  longitude: number;
}

type SuccessCallback = (coords: GeoCoordinates) => void;
type ErrorCallback = (error: unknown) => void;

// 统一定位入口。ASCF（鸿蒙元服务）环境下 navigator.geolocation 已在启动时被
// 替换为鸿蒙SDK实现（见 utils/ascfGeolocation.ts + main.tsx），所以这里
// 只需照常用浏览器 API，不必再区分环境。

// navigator.geolocation.getCurrentPosition
export const getCurrentPosition = (
  onSuccess: SuccessCallback,
  onError?: ErrorCallback
): void => {
  if (!navigator.geolocation) {
    onError?.(new Error('Geolocation is not supported'));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    position => onSuccess(position.coords),
    onError
  );
};

// navigator.geolocation.watchPosition，返回清除函数
export const watchPosition = (
  onSuccess: SuccessCallback,
  onError?: ErrorCallback
): (() => void) => {
  if (!navigator.geolocation) {
    onError?.(new Error('Geolocation is not supported'));
    return () => {};
  }

  navigator.geolocation.getCurrentPosition(
    position => onSuccess(position.coords),
    onError
  );

  const watchId = navigator.geolocation.watchPosition(
    position => onSuccess(position.coords),
    onError
  );
  return () => navigator.geolocation.clearWatch(watchId);
};
